"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungMontagetyp = void 0;
var ZugentlastungMontagetyp;
(function (ZugentlastungMontagetyp) {
    ZugentlastungMontagetyp["CProfilVorAE"] = "C-Profil_vor_AE";
    ZugentlastungMontagetyp["ClipsStegE456"] = "Clips_Steg_E4-56";
    ZugentlastungMontagetyp["Egal"] = "Egal";
    ZugentlastungMontagetyp["HDCProfil"] = "HD_C-Profil";
    ZugentlastungMontagetyp["Kamm2000"] = "Kamm_2000";
    ZugentlastungMontagetyp["Kamm3000"] = "Kamm_3000";
    ZugentlastungMontagetyp["KammSteg2400"] = "Kamm_Steg_2400";
    ZugentlastungMontagetyp["KammSteg3400"] = "Kamm_Steg_3400";
    ZugentlastungMontagetyp["KammStegE432"] = "Kamm_Steg_E4-32";
    ZugentlastungMontagetyp["KammStegE456"] = "Kamm_Steg_E4-56";
    ZugentlastungMontagetyp["KammStegR58"] = "Kamm_Steg_R58";
    ZugentlastungMontagetyp["KammStegR68"] = "Kamm_Steg_R68";
    ZugentlastungMontagetyp["KMACProfil"] = "KMA_C-Profil";
    ZugentlastungMontagetyp["KMACProfilCFV42"] = "KMA_C-Profil_CFV42";
    ZugentlastungMontagetyp["KMACProfilCFV80"] = "KMA_C-Profil_CFV80";
    ZugentlastungMontagetyp["KMACProfilKurz"] = "KMA_C-Profil_Kurz";
    ZugentlastungMontagetyp["KMAE3"] = "KMA_E3";
    ZugentlastungMontagetyp["KMAHutschiene"] = "KMA_Hutschiene";
    ZugentlastungMontagetyp["Steg1400"] = "Steg_1400";
    ZugentlastungMontagetyp["Steg2400"] = "Steg_2400";
    ZugentlastungMontagetyp["Steg2450"] = "Steg_2450";
    ZugentlastungMontagetyp["Steg2600"] = "Steg_2600";
    ZugentlastungMontagetyp["Steg3400"] = "Steg_3400";
    ZugentlastungMontagetyp["Steg3450"] = "Steg_3450";
    ZugentlastungMontagetyp["StegE421"] = "Steg_E4-21";
    ZugentlastungMontagetyp["StegE428"] = "Steg_E4-28";
    ZugentlastungMontagetyp["StegE448L"] = "Steg_E4-48L";
    ZugentlastungMontagetyp["StegE629"] = "Steg_E6-29";
    ZugentlastungMontagetyp["StegE635"] = "Steg_E6-35";
    ZugentlastungMontagetyp["StegE640"] = "Steg_E6-40";
    ZugentlastungMontagetyp["StegR226"] = "Steg_R2_26";
    ZugentlastungMontagetyp["StegR240"] = "Steg_R2_40";
    ZugentlastungMontagetyp["StegR428"] = "Steg_R4-28";
    ZugentlastungMontagetyp["StegR629"] = "Steg_R6-29";
    ZugentlastungMontagetyp["StegR48"] = "Steg_R48";
    ZugentlastungMontagetyp["StegR157"] = "Steg_R157";
    ZugentlastungMontagetyp["StegR167"] = "Steg_R167";
})(ZugentlastungMontagetyp = exports.ZugentlastungMontagetyp || (exports.ZugentlastungMontagetyp = {}));
//# sourceMappingURL=ZugentlastungMontagetyp.js.map